<template>
  <div>
    <div
      class="mb-5 rounded border-l-4 border-green-500 bg-green-100 p-4 text-green-700"
      role="alert"
    >
      <p class="font-bold">
        Great!
      </p>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessNotification',
  props: {
    message: {
      type: String,
      required: true,
    },
  },
}
</script>
